// @ts-nocheck
import ahnkookPharmTemplate from './ahnkookPharm';
import alicoPharmTemplate from './alicoPharm';
import binexTemplate from './binex';
import celltrionPharmTemplate from './celltrionPharm';
import daewooPharmTemplate from './daewooPharm';
import daewoongBioTemplate from './daewoongBio';
import dongkooBioTemplate from './dongkooBio';
import glPharmaTemplate from './glPharma';
import gujuPharmTemplate from './gujuPharm';
import huonsTemplate from './huons';
import hutecsPharmTemplate from './hutecsPharm';
import jeilPharmTemplate from './jeilPharm';
import jinyangPharmTemplate from './jinyangPharm';
import kipsBioPharmaTemplate from './kipsBioPharma';
import koreaPharmaTemplate from './koreaPharma';
import kyungboPharmTemplate from './kyungboPharm';
import mediLinkTemplate from './mediLink';
import mothersPharmTemplate from './mothersPharm';
import samsungPharmTemplate from './samsungPharm';
import teragenEtexTemplate from './teragenEtex';
import withusPharmTemplate from './withusPharm';
import youngjinPharmTemplate from './youngjinPharm';

const settlementTemplates = [
  ahnkookPharmTemplate,
  alicoPharmTemplate,
  binexTemplate,
  celltrionPharmTemplate,
  daewoongBioTemplate,
  dongkooBioTemplate,
  glPharmaTemplate,
  gujuPharmTemplate,
  huonsTemplate,
  hutecsPharmTemplate,
  jeilPharmTemplate,
  jinyangPharmTemplate,
  kipsBioPharmaTemplate,
  koreaPharmaTemplate,
  kyungboPharmTemplate,
  mediLinkTemplate,
  mothersPharmTemplate,
  samsungPharmTemplate,
  teragenEtexTemplate,
  withusPharmTemplate,
  youngjinPharmTemplate,
  daewooPharmTemplate,
];

function resolveSettlementTemplate(context) {
  return (
    settlementTemplates.find((template) => template.match(context)) || null
  );
}

export { settlementTemplates, resolveSettlementTemplate };
